import { motion } from "framer-motion";
import { FaBullseye, FaEye, FaHandshake, FaAward, FaCheckCircle } from "react-icons/fa";

const Card = ({ icon: Icon, title, children, accent }) => (
    <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
        className="relative p-7 sm:p-8 rounded-3xl bg-white dark:bg-slate-900 border border-slate-200/80 dark:border-slate-800 shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all"
    >
        <div className={`w-12 h-12 rounded-2xl flex items-center justify-center text-lg mb-5 ${accent}`}>
            <Icon />
        </div>
        <h3 className="font-heading text-xl font-bold text-slate-900 dark:text-white mb-2">{title}</h3>
        <div className="text-slate-600 dark:text-slate-300 text-sm leading-relaxed">{children}</div>
    </motion.div>
);

const About = () => (
    <section id="about" data-testid="about-section" className="relative py-20 sm:py-28">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                className="max-w-3xl"
            >
                <div className="text-xs font-bold uppercase tracking-[0.25em] text-brand-600 dark:text-brand-300 mb-4">About Us</div>
                <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900 dark:text-white leading-tight">
                    Powering Healthcare with{" "}
                    <span className="text-gradient-brand">Reliable Equipment</span>
                </h2>
                <p className="mt-5 text-slate-600 dark:text-slate-300 text-base sm:text-lg leading-relaxed">
                    Ezhil Biomedical Sales and Services is a Puducherry-based supplier and service provider of premium hospital, surgical, oxygen and laboratory equipment. With over a decade of biomedical expertise, we partner with hospitals, clinics, diagnostic centres and medical institutions to deliver dependable equipment and round-the-clock technical support.
                </p>
            </motion.div>

            <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
                <Card icon={FaEye} title="Our Vision" accent="bg-brand-50 text-brand-700 dark:bg-brand-900/30 dark:text-brand-300">
                    To be South India's most trusted partner for medical equipment sales and biomedical service excellence.
                </Card>
                <Card icon={FaBullseye} title="Our Mission" accent="bg-emerald-50 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-300">
                    Deliver genuine, certified equipment and rapid service so healthcare professionals can focus on saving lives.
                </Card>
                <Card icon={FaHandshake} title="Our Promise" accent="bg-amber-50 text-amber-700 dark:bg-amber-900/30 dark:text-amber-300">
                    Transparent pricing, authentic OEM products and 24×7 service support for every client we serve.
                </Card>
                <Card icon={FaAward} title="Why Choose Us" accent="bg-violet-50 text-violet-700 dark:bg-violet-900/30 dark:text-violet-300">
                    5.0 Google rating, certified engineers and a complete one-stop solution for biomedical needs.
                </Card>
            </div>

            <div className="mt-10 flex flex-wrap gap-4">
                {["ISO Certified Partners", "Authorized Dealers", "Pan-India Brand Network", "NABH/NABL Aligned"].map((t) => (
                    <div key={t} className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-slate-100 dark:bg-slate-800 text-slate-700 dark:text-slate-200 text-sm font-medium">
                        <FaCheckCircle className="text-emerald-500" /> {t}
                    </div>
                ))}
            </div>
        </div>
    </section>
);

export default About;
